var items = {
  "block.minecraft.air": "luff",
  "block.minecraft.stone": "stein",
  "block.minecraft.granite": "jranit",
  "block.minecraft.polished_granite": "poleete jranit",
  "block.minecraft.diorite": "dijorit",
  "block.minecraft.polished_diorite": "poleete dijorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "poleete andesit",
  "block.minecraft.grass_block": "jraasäd",
  "block.minecraft.dirt": "äd",
  "block.minecraft.coarse_dirt": "jrov äd",
  "block.minecraft.podzol": "jrauäd",
  "block.minecraft.crimson_nylium": "karmesinn-nülliöm",
  "block.minecraft.warped_nylium": "jecke-nülliöm",
  "block.minecraft.cobblestone": "brochstein",
  "block.minecraft.oak_planks": "eescheholzbredder",
  "block.minecraft.spruce_planks": "danneholzbredder",
  "block.minecraft.birch_planks": "birkeholzbredder",
  "block.minecraft.jungle_planks": "tropeholzbredder",
  "block.minecraft.acacia_planks": "akazijeholzbredder",
  "block.minecraft.dark_oak_planks": "schwatzeescheholzbredder",
  "block.minecraft.crimson_planks": "karmesinnbredder",
  "block.minecraft.warped_planks": "jeckebredder",
  "block.minecraft.oak_sapling": "eescheböumche",
  "block.minecraft.spruce_sapling": "danneböumche",
  "block.minecraft.birch_sapling": "birkeböumche",
  "block.minecraft.jungle_sapling": "tropeböumche",
  "block.minecraft.acacia_sapling": "akazijeböumche",
  "block.minecraft.dark_oak_sapling": "schwatzeescheböumche",
  "block.minecraft.bedrock": "jrundjestein",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rude sand",
  "block.minecraft.gravel": "kis",
  "block.minecraft.gold_ore": "joldärz",
  "block.minecraft.iron_ore": "ieseärz",
  "block.minecraft.coal_ore": "steinkoll",
  "block.minecraft.nether_gold_ore": "nether-joldärz",
  "block.minecraft.oak_log": "eeschestamm",
  "block.minecraft.spruce_log": "dannestamm",
  "block.minecraft.birch_log": "birkestamm",
  "block.minecraft.jungle_log": "tropestamm",
  "block.minecraft.acacia_log": "akazijestamm",
  "block.minecraft.dark_oak_log": "schwatzeeschestamm",
  "block.minecraft.crimson_stem": "karmesinnstill",
  "block.minecraft.warped_stem": "jeckestill",
  "block.minecraft.stripped_oak_log": "jeschälte eeschestamm",
  "block.minecraft.stripped_spruce_log": "jeschälte dannestamm",
  "block.minecraft.stripped_birch_log": "jeschälte birkestamm",
  "block.minecraft.stripped_jungle_log": "jeschälte tropeholzstamm",
  "block.minecraft.stripped_acacia_log": "jeschälte akazijestamm",
  "block.minecraft.stripped_dark_oak_log": "jeschälte schwatzeeschestamm",
  "block.minecraft.stripped_crimson_stem": "jeschälte karmesinnstill",
  "block.minecraft.stripped_warped_stem": "jeschälte jeckestill",
  "block.minecraft.stripped_oak_wood": "jeschält eescheholz",
  "block.minecraft.stripped_spruce_wood": "jeschält danneholz",
  "block.minecraft.stripped_birch_wood": "jeschält birkeholz",
  "block.minecraft.stripped_jungle_wood": "jeschält tropeholz",
  "block.minecraft.stripped_acacia_wood": "jeschält akazijeholz",
  "block.minecraft.stripped_dark_oak_wood": "jeschält schwatzeescheholz",
  "block.minecraft.stripped_crimson_hyphae": "jeschälte karmesinnhüfe",
  "block.minecraft.stripped_warped_hyphae": "jeschälte jeckehüfe",
  "block.minecraft.oak_wood": "eescheholz",
  "block.minecraft.spruce_wood": "danneholz",
  "block.minecraft.birch_wood": "birkeholz",
  "block.minecraft.jungle_wood": "tropeholz",
  "block.minecraft.acacia_wood": "akazijeholz",
  "block.minecraft.dark_oak_wood": "schwatzeescheholz",
  "block.minecraft.crimson_hyphae": "karmesinnhüfe",
  "block.minecraft.warped_hyphae": "jeckehüfe",
  "block.minecraft.oak_leaves": "eeschelauv",
  "block.minecraft.spruce_leaves": "dannenole",
  "block.minecraft.birch_leaves": "birkelauv",
  "block.minecraft.jungle_leaves": "tropebaumlauv",
  "block.minecraft.acacia_leaves": "akazijelauv",
  "block.minecraft.dark_oak_leaves": "schwatzeeschelauv",
  "block.minecraft.sponge": "schwamm",
  "block.minecraft.wet_sponge": "nasse schwamm",
  "block.minecraft.glass": "jlas",
  "block.minecraft.lapis_ore": "lapislazoliärz",
  "block.minecraft.lapis_block": "lapislazoli",
  "block.minecraft.dispenser": "verdeeler",
  "block.minecraft.sandstone": "sandstein",
  "block.minecraft.chiseled_sandstone": "ziseleete sandstein",
  "block.minecraft.cut_sandstone": "jeschnigge sandstein",
  "block.minecraft.note_block": "musikblock",
  "block.minecraft.powered_rail": "andrevsschinne",
  "block.minecraft.detector_rail": "föhlerschinne",
  "block.minecraft.sticky_piston": "klävkolve",
  "block.minecraft.cobweb": "spenneweb",
  "block.minecraft.grass": "jras",
  "block.minecraft.fern": "farre",
  "block.minecraft.dead_bush": "dude struch",
  "block.minecraft.seagrass": "siejrass",
  "block.minecraft.sea_pickle": "meerjurk",
  "block.minecraft.piston": "kolve",
  "block.minecraft.white_wool": "wieße woll",
  "block.minecraft.orange_wool": "orangsche woll",
  "block.minecraft.magenta_wool": "majenta woll",
  "block.minecraft.light_blue_wool": "hellblaue woll",
  "block.minecraft.yellow_wool": "jäle woll",
  "block.minecraft.lime_wool": "helljröne woll",
  "block.minecraft.pink_wool": "rusa woll",
  "block.minecraft.gray_wool": "jraue woll",
  "block.minecraft.light_gray_wool": "helljraue woll",
  "block.minecraft.cyan_wool": "blaujröne woll",
  "block.minecraft.purple_wool": "vijelette woll",
  "block.minecraft.blue_wool": "blaue woll",
  "block.minecraft.brown_wool": "brunge woll",
  "block.minecraft.green_wool": "jröne woll",
  "block.minecraft.red_wool": "rude woll",
  "block.minecraft.black_wool": "schwatze woll",
  "block.minecraft.dandelion": "ketteblom",
  "block.minecraft.poppy": "klatschrus",
  "block.minecraft.blue_orchid": "blau orschidee",
  "block.minecraft.allium": "öllisch",
  "block.minecraft.azure_bluet": "postelingstähnche",
  "block.minecraft.red_tulip": "rut tulp",
  "block.minecraft.orange_tulip": "orangsch tulp",
  "block.minecraft.white_tulip": "wieße tulp",
  "block.minecraft.pink_tulip": "rusa tulp",
  "block.minecraft.oxeye_daisy": "marjerit",
  "block.minecraft.cornflower": "kornblom",
  "block.minecraft.lily_of_the_valley": "maijlöckche",
  "block.minecraft.wither_rose": "witherrus",
  "block.minecraft.brown_mushroom": "brunge pelz",
  "block.minecraft.red_mushroom": "rude pelz",
  "block.minecraft.crimson_fungus": "karmesinnpelz",
  "block.minecraft.warped_fungus": "jeckepelz",
  "block.minecraft.crimson_roots": "karmesinnwuzzele",
  "block.minecraft.warped_roots": "jeckewuzzele",
  "block.minecraft.nether_sprouts": "nether-sprosse",
  "block.minecraft.weeping_vines": "troorranke",
  "block.minecraft.twisting_vines": "zwirvelranke",
  "block.minecraft.sugar_cane": "zuckerrühr",
  "block.minecraft.kelp": "sietang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "jold",
  "block.minecraft.iron_block": "iese",
  "block.minecraft.oak_slab": "eescheholzstof",
  "block.minecraft.spruce_slab": "danneholzstof",
  "block.minecraft.birch_slab": "birkeholzstof",
  "block.minecraft.jungle_slab": "tropeholzstof",
  "block.minecraft.acacia_slab": "akazijeholzstof",
  "block.minecraft.dark_oak_slab": "schwatzeescheholzstof",
  "block.minecraft.crimson_slab": "karmesinnstof",
  "block.minecraft.warped_slab": "jeckestof",
  "block.minecraft.stone_slab": "steinstof",
  "block.minecraft.smooth_stone_slab": "jlatte steinstof",
  "block.minecraft.sandstone_slab": "sandsteinstof",
  "block.minecraft.cut_sandstone_slab": "jeschnigge sandsteinstof",
  "block.minecraft.petrified_oak_slab": "versteinerte eescheholzstof",
  "block.minecraft.cobblestone_slab": "brochsteinstof",
  "block.minecraft.brick_slab": "ziejelstof",
  "block.minecraft.stone_brick_slab": "steinziejelstof",
  "block.minecraft.nether_brick_slab": "netherziejelstof",
  "block.minecraft.quartz_slab": "kwarzstof",
  "block.minecraft.red_sandstone_slab": "rut sandsteinstof",
  "block.minecraft.cut_red_sandstone_slab": "jeschnigge rut sandsteinstof",
  "block.minecraft.purpur_slab": "purpurstof",
  "block.minecraft.prismarine_slab": "prismarinstof",
  "block.minecraft.prismarine_brick_slab": "prismarinziejelstof",
  "block.minecraft.dark_prismarine_slab": "dunkle prismarinstof",
  "block.minecraft.smooth_quartz": "jlatte kwarzblock",
  "block.minecraft.smooth_red_sandstone": "jlatte rude sandstein",
  "block.minecraft.smooth_sandstone": "jlatte sandstein",
  "block.minecraft.smooth_stone": "jlatte stein",
  "block.minecraft.bricks": "ziejelstein",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "böcherejal",
  "block.minecraft.mossy_cobblestone": "bemoste brochstein",
  "block.minecraft.obsidian": "obssidijan",
  "block.minecraft.torch": "tootsch",
  "block.minecraft.end_rod": "endstang",
  "block.minecraft.chorus_plant": "chorusplant",
  "block.minecraft.chorus_flower": "chorusblom",
  "block.minecraft.purpur_block": "purpur",
  "block.minecraft.purpur_pillar": "purpursül",
  "block.minecraft.purpur_stairs": "purpurtrapp",
  "block.minecraft.spawner": "erzeujer",
  "block.minecraft.oak_stairs": "eescheholztrapp",
  "block.minecraft.chest": "keß",
  "block.minecraft.diamond_ore": "dijamantärz",
  "block.minecraft.diamond_block": "dijamant",
  "block.minecraft.crafting_table": "werkbank",
  "block.minecraft.farmland": "ackeräd",
  "block.minecraft.furnace": "ovve",
  "block.minecraft.ladder": "leeder",
  "block.minecraft.rail": "schinne",
  "block.minecraft.cobblestone_stairs": "brochsteintrapp",
  "block.minecraft.lever": "hävvel",
  "block.minecraft.stone_pressure_plate": "steindröckplaat",
  "block.minecraft.oak_pressure_plate": "eescheholzdröckplaat",
  "block.minecraft.spruce_pressure_plate": "dannedröckplaat",
  "block.minecraft.birch_pressure_plate": "birkeholzdröckplaat",
  "block.minecraft.jungle_pressure_plate": "tropeholzdröckplaat",
  "block.minecraft.acacia_pressure_plate": "akazijeholzdröckplaat",
  "block.minecraft.dark_oak_pressure_plate": "schwatzescheholzdröckplaat",
  "block.minecraft.crimson_pressure_plate": "karmesinndröckplaat",
  "block.minecraft.warped_pressure_plate": "jeckedröckplaat",
  "block.minecraft.polished_blackstone_pressure_plate": "poleete schwatzsteindröckplaat",
  "block.minecraft.redstone_ore": "redstone-ärz",
  "block.minecraft.redstone_torch": "redstone-tootsch",
  "block.minecraft.snow": "schnie",
  "block.minecraft.ice": "ies",
  "block.minecraft.snow_block": "schnieblock",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "klei",
  "block.minecraft.jukebox": "plaatespiller",
  "block.minecraft.oak_fence": "eescheholzzong",
  "block.minecraft.spruce_fence": "danneholzzong",
  "block.minecraft.birch_fence": "birkeholzzong",
  "block.minecraft.jungle_fence": "tropeholzzong",
  "block.minecraft.acacia_fence": "akazijeholzzong",
  "block.minecraft.dark_oak_fence": "schwatzeescheholzzong",
  "block.minecraft.crimson_fence": "karmesinnzong",
  "block.minecraft.warped_fence": "jeckezong",
  "block.minecraft.pumpkin": "kürbis",
  "block.minecraft.carved_pumpkin": "jeschnitze kürbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sielesand",
  "block.minecraft.soul_soil": "sieleäd",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "poleete basalt",
  "block.minecraft.soul_torch": "sieletootsch",
  "block.minecraft.glowstone": "jlowstone",
  "block.minecraft.jack_o_lantern": "kürbislatän",
  "block.minecraft.oak_trapdoor": "eescheholztrappdür",
  "block.minecraft.spruce_trapdoor": "danneholztrappdür",
  "block.minecraft.birch_trapdoor": "birkeholztrappdür",
  "block.minecraft.jungle_trapdoor": "tropeholztrappdür",
  "block.minecraft.acacia_trapdoor": "akazijeholztrappdür",
  "block.minecraft.dark_oak_trapdoor": "schwatzeescheholztrappdür",
  "block.minecraft.crimson_trapdoor": "karmesinntrappdür",
  "block.minecraft.warped_trapdoor": "jecketrappdür",
  "block.minecraft.infested_stone": "befallene stein",
  "block.minecraft.infested_cobblestone": "befallene brochstein",
  "block.minecraft.infested_stone_bricks": "befallene steinziejel",
  "block.minecraft.infested_mossy_stone_bricks": "befallene bemoste steinziejel",
  "block.minecraft.infested_cracked_stone_bricks": "befallene jeresse steinziejel",
  "block.minecraft.infested_chiseled_stone_bricks": "befallene ziseleet steinziejel",
  "block.minecraft.stone_bricks": "steinziejel",
  "block.minecraft.mossy_stone_bricks": "bemoste steinziejel",
  "block.minecraft.cracked_stone_bricks": "jeresse steinziejel",
  "block.minecraft.chiseled_stone_bricks": "ziseleete steinziejel",
  "block.minecraft.brown_mushroom_block": "brunge pelz",
  "block.minecraft.red_mushroom_block": "rude pelz",
  "block.minecraft.mushroom_stem": "pelzstill",
  "block.minecraft.iron_bars": "iesejidder",
  "block.minecraft.chain": "kett",
  "block.minecraft.glass_pane": "jlasschiev",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "ranke",
  "block.minecraft.oak_fence_gate": "eescheholzjadder",
  "block.minecraft.spruce_fence_gate": "danneholzjadder",
  "block.minecraft.birch_fence_gate": "birkeholzjadder",
  "block.minecraft.jungle_fence_gate": "tropeholzjadder",
  "block.minecraft.acacia_fence_gate": "akazijeholzjadder",
  "block.minecraft.dark_oak_fence_gate": "schwatzeescheholzjadder",
  "block.minecraft.crimson_fence_gate": "karmesinnjadder",
  "block.minecraft.warped_fence_gate": "jeckejadder",
  "block.minecraft.brick_stairs": "ziejeltrapp",
  "block.minecraft.stone_brick_stairs": "steinziejeltrapp",
  "block.minecraft.mycelium": "pelzäd",
  "block.minecraft.lily_pad": "sierusejröns",
  "block.minecraft.nether_bricks": "netherziejel",
  "block.minecraft.cracked_nether_bricks": "jeresse netherziejel",
  "block.minecraft.chiseled_nether_bricks": "ziseleete netherziejel",
  "block.minecraft.nether_brick_fence": "netherziejelzong",
  "block.minecraft.nether_brick_stairs": "netherziejeltrapp",
  "block.minecraft.enchanting_table": "zauberdesch",
  "block.minecraft.end_portal_frame": "endpoazrohme",
  "block.minecraft.end_stone": "endstein",
  "block.minecraft.end_stone_bricks": "endsteinziejel",
  "block.minecraft.dragon_egg": "drache-ei",
  "block.minecraft.redstone_lamp": "redstone-lamp",
  "block.minecraft.sandstone_stairs": "sandsteintrapp",
  "block.minecraft.emerald_ore": "smarakärz",
  "block.minecraft.ender_chest": "enderkeß",
  "block.minecraft.tripwire_hook": "hoke",
  "block.minecraft.emerald_block": "smarak",
  "block.minecraft.spruce_stairs": "danneholztrapp",
  "block.minecraft.birch_stairs": "birkeholztrapp",
  "block.minecraft.jungle_stairs": "tropeholztrapp",
  "block.minecraft.crimson_stairs": "karmesinntrapp",
  "block.minecraft.warped_stairs": "jecketrapp",
  "block.minecraft.command_block": "befellsblock",
  "block.minecraft.beacon": "lööchför",
  "block.minecraft.cobblestone_wall": "brochsteinmor",
  "block.minecraft.mossy_cobblestone_wall": "bemoste brochsteinmor",
  "block.minecraft.brick_wall": "ziejelsteinmor",
  "block.minecraft.prismarine_wall": "prismarinmor",
  "block.minecraft.red_sandstone_wall": "rut sandsteinmor",
  "block.minecraft.mossy_stone_brick_wall": "bemoste steinziejelmor",
  "block.minecraft.granite_wall": "jranitmor",
  "block.minecraft.stone_brick_wall": "steinziejelmor",
  "block.minecraft.nether_brick_wall": "netherziejelmor",
  "block.minecraft.andesite_wall": "andesitmor",
  "block.minecraft.red_nether_brick_wall": "rude netherziejelmor",
  "block.minecraft.sandstone_wall": "sandsteinmor",
  "block.minecraft.end_stone_brick_wall": "endsteinziejelmor",
  "block.minecraft.diorite_wall": "dijoritmor",
  "block.minecraft.blackstone_wall": "schwarzsteinmor",
  "block.minecraft.polished_blackstone_wall": "poleete schwatzsteinmor",
  "block.minecraft.polished_blackstone_brick_wall": "poleete schwatzsteinziejelmor",
  "block.minecraft.stone_button": "steinknopp",
  "block.minecraft.oak_button": "schwatzeescheholzknopp",
  "block.minecraft.spruce_button": "danneholzknopp",
  "block.minecraft.birch_button": "birkeholzknopp",
  "block.minecraft.jungle_button": "tropeholzknopp",
  "block.minecraft.acacia_button": "akazijeholzknopp",
  "block.minecraft.dark_oak_button": "schwatzeescheholzknopp",
  "block.minecraft.crimson_button": "karmesinnknopp",
  "block.minecraft.warped_button": "jeckeknopp",
  "block.minecraft.polished_blackstone_button": "poleete schwatzsteinknop",
  "block.minecraft.anvil": "amboß",
  "block.minecraft.chipped_anvil": "anjedötsche amboß",
  "block.minecraft.damaged_anvil": "zerblötsch amboß",
  "block.minecraft.trapped_chest": "trickkeß",
  "block.minecraft.light_weighted_pressure_plate": "joldene wäjeplaat",
  "block.minecraft.heavy_weighted_pressure_plate": "ieser wäjeplaat",
  "block.minecraft.daylight_detector": "dachleechföhler",
  "block.minecraft.redstone_block": "redstone-block",
  "block.minecraft.nether_quartz_ore": "netherkwarzärz",
  "block.minecraft.hopper": "treechter",
  "block.minecraft.chiseled_quartz_block": "ziseleete kwarz",
  "block.minecraft.quartz_block": "kwarz",
  "block.minecraft.quartz_bricks": "kwarzziejel",
  "block.minecraft.quartz_pillar": "kwarzsül",
  "block.minecraft.quartz_stairs": "kwarztrapp",
  "block.minecraft.activator_rail": "aktiveerongsschinne",
  "block.minecraft.dropper": "usjevver",
  "block.minecraft.white_terracotta": "wieß steinjot",
  "block.minecraft.orange_terracotta": "orangsch steinjot",
  "block.minecraft.magenta_terracotta": "majenta steinjot",
  "block.minecraft.light_blue_terracotta": "hellblau steinjot",
  "block.minecraft.yellow_terracotta": "jäl steinjot",
  "block.minecraft.lime_terracotta": "helljrön steinjot",
  "block.minecraft.pink_terracotta": "rusa steinjot",
  "block.minecraft.gray_terracotta": "jrau steinjot",
  "block.minecraft.light_gray_terracotta": "helljrau steinjot",
  "block.minecraft.cyan_terracotta": "blaujrön steinjot",
  "block.minecraft.purple_terracotta": "vijelett steinjot",
  "block.minecraft.blue_terracotta": "blau steinjot",
  "block.minecraft.brown_terracotta": "brung steinjot",
  "block.minecraft.green_terracotta": "jrön steinjot",
  "block.minecraft.red_terracotta": "rut steinjot",
  "block.minecraft.black_terracotta": "schwatz steinjot",
  "block.minecraft.barrier": "barrjär",
  "block.minecraft.iron_trapdoor": "iesetrappdür",
  "block.minecraft.hay_block": "strühballe",
  "block.minecraft.white_carpet": "wieße teppich",
  "block.minecraft.orange_carpet": "orangsche teppich",
  "block.minecraft.magenta_carpet": "majenta teppich",
  "block.minecraft.light_blue_carpet": "hellblaue teppich",
  "block.minecraft.yellow_carpet": "jäle teppich",
  "block.minecraft.lime_carpet": "helljröne teppich",
  "block.minecraft.pink_carpet": "rusa teppich",
  "block.minecraft.gray_carpet": "jraue teppich",
  "block.minecraft.light_gray_carpet": "helljraue teppich",
  "block.minecraft.cyan_carpet": "blaujröne teppich",
  "block.minecraft.purple_carpet": "vijelette teppich",
  "block.minecraft.blue_carpet": "blaue teppich",
  "block.minecraft.brown_carpet": "brunge teppich",
  "block.minecraft.green_carpet": "jröne teppich",
  "block.minecraft.red_carpet": "rude teppich",
  "block.minecraft.black_carpet": "schwatze teppich",
  "block.minecraft.terracotta": "steinjot",
  "block.minecraft.coal_block": "koll",
  "block.minecraft.packed_ice": "packies",
  "block.minecraft.acacia_stairs": "akazijeholztrapp",
  "block.minecraft.dark_oak_stairs": "schwatzeescheholztrapp",
  "block.minecraft.slime_block": "schliem",
  "block.minecraft.grass_path": "drampelspad",
  "block.minecraft.sunflower": "sunneblom",
  "block.minecraft.lilac": "fleere",
  "block.minecraft.rose_bush": "rusestruch",
  "block.minecraft.peony": "pingsrus",
  "block.minecraft.tall_grass": "huh jras",
  "block.minecraft.large_fern": "huhe farre",
  "block.minecraft.white_stained_glass": "wieß jefärv jlas",
  "block.minecraft.orange_stained_glass": "orangsch jefärv jlas",
  "block.minecraft.magenta_stained_glass": "majenta jefärv jlas",
  "block.minecraft.light_blue_stained_glass": "hellblau jefärv jlas",
  "block.minecraft.yellow_stained_glass": "jäl jefärv jlas",
  "block.minecraft.lime_stained_glass": "helljrön jefärv jlas",
  "block.minecraft.pink_stained_glass": "rusa jefärv jlas",
  "block.minecraft.gray_stained_glass": "jrau jefärv jlas",
  "block.minecraft.light_gray_stained_glass": "helljrau jefärv jlas",
  "block.minecraft.cyan_stained_glass": "blaujrön jefeärv jlas",
  "block.minecraft.purple_stained_glass": "vijelett jefärv jlas",
  "block.minecraft.blue_stained_glass": "blau jefärv jlas",
  "block.minecraft.brown_stained_glass": "brung jefärv jlas",
  "block.minecraft.green_stained_glass": "jrön jefärv jlas",
  "block.minecraft.red_stained_glass": "rut jefärv jlas",
  "block.minecraft.black_stained_glass": "schwatz jefärv jlas",
  "block.minecraft.white_stained_glass_pane": "wieß jefärv jlasschiev",
  "block.minecraft.orange_stained_glass_pane": "orangsch jefärv jlasschiev",
  "block.minecraft.magenta_stained_glass_pane": "majenta jefärv jlasschiev",
  "block.minecraft.light_blue_stained_glass_pane": "hellblau jefärv jlasschiev",
  "block.minecraft.yellow_stained_glass_pane": "jäl jefärv jlasschiev",
  "block.minecraft.lime_stained_glass_pane": "helljrön jefärv jlasschiev",
  "block.minecraft.pink_stained_glass_pane": "rusa jefärv jlasschiev",
  "block.minecraft.gray_stained_glass_pane": "jrau jefärv jlasschiev",
  "block.minecraft.light_gray_stained_glass_pane": "helljrau jefärv jlasschiev",
  "block.minecraft.cyan_stained_glass_pane": "blaujrön jefeärv jlasschiev",
  "block.minecraft.purple_stained_glass_pane": "vijelett jefärv jlasschiev",
  "block.minecraft.blue_stained_glass_pane": "blau jefärv jlasschiev",
  "block.minecraft.brown_stained_glass_pane": "brung jefärv jlasschiev",
  "block.minecraft.green_stained_glass_pane": "jrön jefärv jlasschiev",
  "block.minecraft.red_stained_glass_pane": "rut jefärv jlasschiev",
  "block.minecraft.black_stained_glass_pane": "schwatz jefärv jlasschiev",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinziejel",
  "block.minecraft.dark_prismarine": "dunkle prismarin",
  "block.minecraft.prismarine_stairs": "prismarintrapp",
  "block.minecraft.prismarine_brick_stairs": "prismarinziejeltrapp",
  "block.minecraft.dark_prismarine_stairs": "dunkle prismarintrapp",
  "block.minecraft.sea_lantern": "sielatän",
  "block.minecraft.red_sandstone": "rude sandstein",
  "block.minecraft.chiseled_red_sandstone": "ziseleete rude sandstein",
  "block.minecraft.cut_red_sandstone": "jeschnigge rude sandstein",
  "block.minecraft.red_sandstone_stairs": "rut sandsteintrapp",
  "block.minecraft.repeating_command_block": "widderhol-befellsblock",
  "block.minecraft.chain_command_block": "kette-befellsblock",
  "block.minecraft.magma_block": "machma",
  "block.minecraft.nether_wart_block": "netherwaazeblock",
  "block.minecraft.warped_wart_block": "jeckewaazeblock",
  "block.minecraft.red_nether_bricks": "rude netherziejel",
  "block.minecraft.bone_block": "knoche",
  "block.minecraft.structure_void": "konstrukzijonsleddischkeit",
  "block.minecraft.observer": "lorer",
  "block.minecraft.shulker_box": "shulkerkeß",
  "block.minecraft.white_shulker_box": "wieße shulkerkeß",
  "block.minecraft.orange_shulker_box": "orangsch shulkerkeß",
  "block.minecraft.magenta_shulker_box": "majenta shulkerkeß",
  "block.minecraft.light_blue_shulker_box": "hellblaue shulkerkeß",
  "block.minecraft.yellow_shulker_box": "jäl shulkerkeß",
  "block.minecraft.lime_shulker_box": "helljrön shulkerkeß",
  "block.minecraft.pink_shulker_box": "rusa shulkerkeß",
  "block.minecraft.gray_shulker_box": "jrau shulkerkeß",
  "block.minecraft.light_gray_shulker_box": "helljrau shulkerkeß",
  "block.minecraft.cyan_shulker_box": "blaujrön shulkerkeß",
  "block.minecraft.purple_shulker_box": "vijelette shulkerkeß",
  "block.minecraft.blue_shulker_box": "blau shulkerkeß",
  "block.minecraft.brown_shulker_box": "brung shulkerkeß",
  "block.minecraft.green_shulker_box": "jrön shulkerkeß",
  "block.minecraft.red_shulker_box": "rut shulkerkeß",
  "block.minecraft.black_shulker_box": "schwatz shulkerkeß",
  "block.minecraft.white_glazed_terracotta": "wieß jlaseet steinjot",
  "block.minecraft.orange_glazed_terracotta": "orangsch jlaseet steinjot",
  "block.minecraft.magenta_glazed_terracotta": "majenta jlaseet steinjot",
  "block.minecraft.light_blue_glazed_terracotta": "hellblau jlaseet steinjot",
  "block.minecraft.yellow_glazed_terracotta": "jäl jlaseet steinjot",
  "block.minecraft.lime_glazed_terracotta": "helljrön jlaseet steinjot",
  "block.minecraft.pink_glazed_terracotta": "rusa jlaseet steinjot",
  "block.minecraft.gray_glazed_terracotta": "jrau jlaseet steinjot",
  "block.minecraft.light_gray_glazed_terracotta": "helljrau jlaseet steinjot",
  "block.minecraft.cyan_glazed_terracotta": "blaujrön jlaseet steinjot",
  "block.minecraft.purple_glazed_terracotta": "vijelett jlaseet steinjot",
  "block.minecraft.blue_glazed_terracotta": "blau jlaseet steinjot",
  "block.minecraft.brown_glazed_terracotta": "brung jlaseet steinjot",
  "block.minecraft.green_glazed_terracotta": "jrön jlaseet steinjot",
  "block.minecraft.red_glazed_terracotta": "rut jlaseet steinjot",
  "block.minecraft.black_glazed_terracotta": "schwatz jlaseet steinjot",
  "block.minecraft.white_concrete": "wieße betong",
  "block.minecraft.orange_concrete": "orangsche betong",
  "block.minecraft.magenta_concrete": "majenta betong",
  "block.minecraft.light_blue_concrete": "hellblaue betong",
  "block.minecraft.yellow_concrete": "jäle betong",
  "block.minecraft.lime_concrete": "helljröne betong",
  "block.minecraft.pink_concrete": "rusa betong",
  "block.minecraft.gray_concrete": "jraue betong",
  "block.minecraft.light_gray_concrete": "helljraue betong",
  "block.minecraft.cyan_concrete": "blaujröne betong",
  "block.minecraft.purple_concrete": "vijelette betong",
  "block.minecraft.blue_concrete": "blaue betong",
  "block.minecraft.brown_concrete": "brunge betong",
  "block.minecraft.green_concrete": "jröne betong",
  "block.minecraft.red_concrete": "rude betong",
  "block.minecraft.black_concrete": "schwatze betong",
  "block.minecraft.white_concrete_powder": "wieße drüchbetong",
  "block.minecraft.orange_concrete_powder": "orangsche drüchbetong",
  "block.minecraft.magenta_concrete_powder": "majenta drüchbetong",
  "block.minecraft.light_blue_concrete_powder": "hellblaue drüchbetong",
  "block.minecraft.yellow_concrete_powder": "jäle drüchbetong",
  "block.minecraft.lime_concrete_powder": "helljröne drüchbetong",
  "block.minecraft.pink_concrete_powder": "rusa drüchbetong",
  "block.minecraft.gray_concrete_powder": "jraue drüchbetong",
  "block.minecraft.light_gray_concrete_powder": "helljraue drüchbetong",
  "block.minecraft.cyan_concrete_powder": "blaujröne drüchbetong",
  "block.minecraft.purple_concrete_powder": "vijelette drüchbetong",
  "block.minecraft.blue_concrete_powder": "blaue drüchbetong",
  "block.minecraft.brown_concrete_powder": "brunge drüchbetong",
  "block.minecraft.green_concrete_powder": "jröne drüchbetong",
  "block.minecraft.red_concrete_powder": "rude drüchbetong",
  "block.minecraft.black_concrete_powder": "schwatze drüchbetong",
  "block.minecraft.turtle_egg": "scheldkraate-ei",
  "block.minecraft.dead_tube_coral_block": "dude orjelkoralleblock",
  "block.minecraft.dead_brain_coral_block": "dude jehirnkoralleblock",
  "block.minecraft.dead_bubble_coral_block": "dude blosekoralleblock",
  "block.minecraft.dead_fire_coral_block": "dude förkoralleblock",
  "block.minecraft.dead_horn_coral_block": "dude jeweihkoralleblock",
  "block.minecraft.tube_coral_block": "orjelkoralleblock",
  "block.minecraft.brain_coral_block": "jehirnkoralleblock",
  "block.minecraft.bubble_coral_block": "blosekoralleblock",
  "block.minecraft.fire_coral_block": "förkoralleblock",
  "block.minecraft.horn_coral_block": "jeweihkoralleblock",
  "block.minecraft.tube_coral": "orjelkorall",
  "block.minecraft.brain_coral": "jehirnkorall",
  "block.minecraft.bubble_coral": "blosekorall",
  "block.minecraft.fire_coral": "förkorall",
  "block.minecraft.horn_coral": "jeweihkorall",
  "block.minecraft.dead_brain_coral": "dude jehirnkorall",
  "block.minecraft.dead_bubble_coral": "dude blosekorall",
  "block.minecraft.dead_fire_coral": "dude förkorall",
  "block.minecraft.dead_horn_coral": "dude jeweihkorall",
  "block.minecraft.dead_tube_coral": "dude orjelkorall",
  "block.minecraft.tube_coral_fan": "orjelkorallefächer",
  "block.minecraft.brain_coral_fan": "jehirnkorallefächer",
  "block.minecraft.bubble_coral_fan": "blosekorallefächer",
  "block.minecraft.fire_coral_fan": "förkorallefächer",
  "block.minecraft.horn_coral_fan": "jeweihkorallefächer",
  "block.minecraft.dead_tube_coral_fan": "dude orjelkorallefächer",
  "block.minecraft.dead_brain_coral_fan": "dude jehirnkorallefächer",
  "block.minecraft.dead_bubble_coral_fan": "dude blosekorallefächer",
  "block.minecraft.dead_fire_coral_fan": "dude förkorallefächer",
  "block.minecraft.dead_horn_coral_fan": "dude jeweihkorallefächer",
  "block.minecraft.blue_ice": "blauies",
  "block.minecraft.conduit": "aquisatör",
  "block.minecraft.polished_granite_stairs": "poleete jranittrapp",
  "block.minecraft.smooth_red_sandstone_stairs": "jlatte rude sandsteintrapp",
  "block.minecraft.mossy_stone_brick_stairs": "bemoste steinziejeltrapp",
  "block.minecraft.polished_diorite_stairs": "poleete dijorittrapp",
  "block.minecraft.mossy_cobblestone_stairs": "bemoste brochsteintrapp",
  "block.minecraft.end_stone_brick_stairs": "endsteinziejeltrapp",
  "block.minecraft.stone_stairs": "steintrapp",
  "block.minecraft.smooth_sandstone_stairs": "jlatte steintrapp",
  "block.minecraft.smooth_quartz_stairs": "jlatte kwarztrapp",
  "block.minecraft.granite_stairs": "jranittrapp",
  "block.minecraft.andesite_stairs": "andesittrapp",
  "block.minecraft.red_nether_brick_stairs": "rude netherziejeltrapp",
  "block.minecraft.polished_andesite_stairs": "poleete andesittrapp",
  "block.minecraft.diorite_stairs": "dijorittrapp",
  "block.minecraft.polished_granite_slab": "poleete jranitstof",
  "block.minecraft.smooth_red_sandstone_slab": "jlatte rude sandsteinstof",
  "block.minecraft.mossy_stone_brick_slab": "bemoste steinziejelstof",
  "block.minecraft.polished_diorite_slab": "poleete dijoritstof",
  "block.minecraft.mossy_cobblestone_slab": "bemoste brochsteinstof",
  "block.minecraft.end_stone_brick_slab": "endsteinziejelstof",
  "block.minecraft.smooth_sandstone_slab": "jlatte sandsteinstof",
  "block.minecraft.smooth_quartz_slab": "jlatte kwarzstof",
  "block.minecraft.granite_slab": "jranitstof",
  "block.minecraft.andesite_slab": "andesitstof",
  "block.minecraft.red_nether_brick_slab": "rude netherziejelstof",
  "block.minecraft.polished_andesite_slab": "poleete andesitstof",
  "block.minecraft.diorite_slab": "dijoritstof",
  "block.minecraft.scaffolding": "jerös",
  "block.minecraft.iron_door": "iesedür",
  "block.minecraft.oak_door": "eescheholzdür",
  "block.minecraft.spruce_door": "danneholzdür",
  "block.minecraft.birch_door": "birkeholzdür",
  "block.minecraft.jungle_door": "tropeholzdür",
  "block.minecraft.acacia_door": "akazijeholzdür",
  "block.minecraft.dark_oak_door": "schwatzeescheholzdür",
  "block.minecraft.crimson_door": "karmesinndür",
  "block.minecraft.warped_door": "jeckedür",
  "block.minecraft.repeater": "redstone-verstärke",
  "block.minecraft.comparator": "redstone-verjliche",
  "block.minecraft.structure_block": "konstrukzijonsblock",
  "block.minecraft.jigsaw": "pusselblock",
  "item.minecraft.turtle_helmet": "scheldkraatepanzer□□om kopp:□+2 röstung",
  "item.minecraft.scute": "hornscheld",
  "item.minecraft.iron_shovel": "ieseschöpp□□en dä hauphand:□+3.5 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.iron_pickaxe": "iesepielhau□□en dä hauphand:□+3 anjreffsschade□-2.8 anjreffsjeschwindechkeet",
  "item.minecraft.iron_axe": "ieseax□□en dä hauphand:□+8 anjreffsschade□-3.1 anjreffsjeschwindechkeet",
  "item.minecraft.flint_and_steel": "förzüch",
  "item.minecraft.apple": "appel",
  "item.minecraft.bow": "flitschborre",
  "item.minecraft.arrow": "piel",
  "item.minecraft.coal": "koll",
  "item.minecraft.charcoal": "holzkoll",
  "item.minecraft.diamond": "dijamant",
  "item.minecraft.iron_ingot": "iesebrikett",
  "item.minecraft.gold_ingot": "joldbrikett",
  "item.minecraft.netherite_ingot": "netheritbrikett",
  "item.minecraft.netherite_scrap": "netheritplaate",
  "item.minecraft.iron_sword": "ieseschwäät□□en dä hauphand:□+5 anjreffsschade□-2.4 anjreffsjeschwindechkeet",
  "item.minecraft.wooden_sword": "holzschwäät□□en dä hauphand:□+3 anjreffsschade□-2.4 anjreffsjeschwindechkeet",
  "item.minecraft.wooden_shovel": "holzschöpp□□en dä hauphand:□+1.5 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.wooden_pickaxe": "holzpielhau□□en dä hauphand:□+1 anjreffsschade□-2.8 anjreffsjeschwindechkeet",
  "item.minecraft.wooden_axe": "holzax□□en dä hauphand:□+6 anjreffsschade□-3.2 anjreffsjeschwindechkeet",
  "item.minecraft.stone_sword": "steinschwäät□□en dä hauphand:□+4 anjreffsschade□-2.4 anjreffsjeschwindechkeet",
  "item.minecraft.stone_shovel": "steinschöpp□□en dä hauphand:□+2.5 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.stone_pickaxe": "steinpielhau□□en dä hauphand:□+2 anjreffsschade□-2.8 anjreffsjeschwindechkeet",
  "item.minecraft.stone_axe": "steinax□□en dä hauphand:□+8 anjreffsschade□-3.2 anjreffsjeschwindechkeet",
  "item.minecraft.diamond_sword": "dijamantschwäät□□en dä hauphand:□+6 anjreffsschade□-2.4 anjreffsjeschwindechkeet",
  "item.minecraft.diamond_shovel": "dijamantschöpp□□en dä hauphand:□+4.5 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.diamond_pickaxe": "dijamantpielhau□□en dä hauphand:□+4 anjreffsschade□-2.8 anjreffsjeschwindechkeet",
  "item.minecraft.diamond_axe": "dijamantax□□en dä hauphand:□+8 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.stick": "stock",
  "item.minecraft.bowl": "kump",
  "item.minecraft.mushroom_stew": "pelzzupp",
  "item.minecraft.golden_sword": "joldschwäät□□en dä hauphand:□+3 anjreffsschade□-2.4 anjreffsjeschwindechkeet",
  "item.minecraft.golden_shovel": "joldschöpp□□en dä hauphand:□+1.5 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.golden_pickaxe": "joldpielhau□□en dä hauphand:□+1 anjreffsschade□-2.8 anjreffsjeschwindechkeet",
  "item.minecraft.golden_axe": "joldax□□en dä hauphand:□+6 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.netherite_sword": "netheritschwäät□□en dä hauphand:□+7 anjreffsschade□-2.4 anjreffsjeschwindechkeet",
  "item.minecraft.netherite_shovel": "netheritschöpp□□en dä hauphand:□+5.5 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.netherite_pickaxe": "netheritpielhau□□en dä hauphand:□+5 anjreffsschade□-2.8 anjreffsjeschwindechkeet",
  "item.minecraft.netherite_axe": "netheritax□□en dä hauphand:□+9 anjreffsschade□-3 anjreffsjeschwindechkeet",
  "item.minecraft.string": "fäddem",
  "item.minecraft.feather": "fädder",
  "item.minecraft.gunpowder": "schwatzpolver",
  "item.minecraft.wooden_hoe": "holzhau□□en dä hauphand:□-3 anjreffsjeschwindechkeet",
  "item.minecraft.stone_hoe": "steinhau□□en dä hauphand:□-2 anjreffsjeschwindechkeet",
  "item.minecraft.iron_hoe": "iesehau□□en dä hauphand:□-1 anjreffsjeschwindechkeet",
  "item.minecraft.diamond_hoe": "dijamanthau□□en dä hauphand:",
  "item.minecraft.golden_hoe": "joldhau□□en dä hauphand:□-3 anjreffsjeschwindechkeet",
  "item.minecraft.netherite_hoe": "netherithau□□en dä hauphand:",
  "item.minecraft.wheat_seeds": "weizesome",
  "item.minecraft.wheat": "weizze",
  "item.minecraft.bread": "brut",
  "item.minecraft.leather_helmet": "leddermötz□□om kopp:□+1 röstung",
  "item.minecraft.leather_chestplate": "ledderjopp□□am balsch:□+3 röstung",
  "item.minecraft.leather_leggings": "ledderbotz□□an de been:□+2 röstung",
  "item.minecraft.leather_boots": "ledderstivvel□□an de föß:□+1 röstung",
  "item.minecraft.chainmail_helmet": "kettemötz□□om kopp:□+2 röstung",
  "item.minecraft.chainmail_chestplate": "kettehemp□□am balsch:□+5 röstung",
  "item.minecraft.chainmail_leggings": "kettebotz□□an de been:□+4 röstung",
  "item.minecraft.chainmail_boots": "kettestivvel□□an de föß:□+1 röstung",
  "item.minecraft.iron_helmet": "iesehellm□□om kopp:□+2 röstung",
  "item.minecraft.iron_chestplate": "ieseharnisch□□am balsch:□+6 röstung",
  "item.minecraft.iron_leggings": "iesebotz□□an de been:□+5 röstung",
  "item.minecraft.iron_boots": "iesestivvel□□an de föß:□+2 röstung",
  "item.minecraft.diamond_helmet": "dijamanthellm□□om kopp:□+3 röstung□+2 röstungshärt",
  "item.minecraft.diamond_chestplate": "dijamantharnisch□□am balsch:□+8 röstung□+2 röstungshärt",
  "item.minecraft.diamond_leggings": "dijamantbotz□□an de been:□+6 röstung□+2 röstungshärt",
  "item.minecraft.diamond_boots": "dijamantstivvel□□an de föß:□+3 röstung□+2 röstungshärt",
  "item.minecraft.golden_helmet": "joldhellm□□om kopp:□+2 röstung",
  "item.minecraft.golden_chestplate": "joldharnisch□□am balsch:□+5 röstung",
  "item.minecraft.golden_leggings": "joldbotz□□an de been:□+3 röstung",
  "item.minecraft.golden_boots": "joldkamasche□□an de föß:□+1 röstung",
  "item.minecraft.netherite_helmet": "netherithellm□□om kopp:□+3 röstung□+3 röstungshärt□+1 standfestichkeet",
  "item.minecraft.netherite_chestplate": "netheritharnisch□□am balsch:□+8 röstung□+3 röstungshärt□+1 standfestichkeet",
  "item.minecraft.netherite_leggings": "netheritbotz□□an de been:□+6 röstung□+3 röstungshärt□+1 standfestichkeet",
  "item.minecraft.netherite_boots": "netheritstivvel□□an de föß:□+3 röstung□+3 röstungshärt□+1 standfestichkeet",
  "item.minecraft.flint": "förstein",
  "item.minecraft.porkchop": "rüh schweinefleisch",
  "item.minecraft.cooked_porkchop": "hämmche",
  "item.minecraft.painting": "jemälde",
  "item.minecraft.golden_apple": "joldene appel",
  "item.minecraft.enchanted_golden_apple": "verzauberte joldene appel",
  "block.minecraft.oak_sign": "eescheholzscheld",
  "block.minecraft.spruce_sign": "danneholzscheld",
  "block.minecraft.birch_sign": "birkeholzscheld",
  "block.minecraft.jungle_sign": "tropeholzscheld",
  "block.minecraft.acacia_sign": "akazijeholzscheld",
  "block.minecraft.dark_oak_sign": "schwatzeescheholzscheld",
  "block.minecraft.crimson_sign": "karmesinnscheld",
  "block.minecraft.warped_sign": "jeckescheld",
  "item.minecraft.bucket": "emmer",
  "item.minecraft.water_bucket": "wasseremmer",
  "item.minecraft.lava_bucket": "lavaemmer",
  "item.minecraft.minecart": "kar",
  "item.minecraft.saddle": "saddel",
  "item.minecraft.redstone": "redstone-stöbb",
  "item.minecraft.snowball": "schnieball",
  "item.minecraft.oak_boat": "eescheholzböötche",
  "item.minecraft.leather": "ledder",
  "item.minecraft.milk_bucket": "melleschemmer",
  "item.minecraft.pufferfish_bucket": "kujelfeschemmer",
  "item.minecraft.salmon_bucket": "lachsemmer",
  "item.minecraft.cod_bucket": "kabbeljauemmer",
  "item.minecraft.tropical_fish_bucket": "tropefeschemmer",
  "item.minecraft.brick": "ziejel",
  "item.minecraft.clay_ball": "kleiklumpe",
  "block.minecraft.dried_kelp_block": "drüjje sietangblock",
  "item.minecraft.paper": "papeer",
  "item.minecraft.book": "boch",
  "item.minecraft.slime_ball": "schliemball",
  "item.minecraft.chest_minecart": "fraachkar",
  "item.minecraft.furnace_minecart": "lokemotiv",
  "item.minecraft.egg": "ei",
  "item.minecraft.compass": "kompaß",
  "item.minecraft.fishing_rod": "feschjät",
  "item.minecraft.clock": "ohr",
  "item.minecraft.glowstone_dust": "jlowstone-stöbb",
  "item.minecraft.cod": "rühe kabbeljau",
  "item.minecraft.salmon": "rühe lachs",
  "item.minecraft.tropical_fish": "tropefesch",
  "item.minecraft.pufferfish": "kujelfesch",
  "item.minecraft.cooked_cod": "jebrode kabbeljau",
  "item.minecraft.cooked_salmon": "jebrode lachs",
  "item.minecraft.ink_sac": "inkbüggel",
  "item.minecraft.red_dye": "rude färv",
  "item.minecraft.green_dye": "jrön färv",
  "item.minecraft.cocoa_beans": "kakaubunne",
  "item.minecraft.lapis_lazuli": "lapislazoli",
  "item.minecraft.purple_dye": "vijelett färv",
  "item.minecraft.cyan_dye": "blaujrön färv",
  "item.minecraft.light_gray_dye": "helljrau färv",
  "item.minecraft.gray_dye": "jrau färv",
  "item.minecraft.pink_dye": "rusa färv",
  "item.minecraft.lime_dye": "helljrön färv",
  "item.minecraft.yellow_dye": "jäl färv",
  "item.minecraft.light_blue_dye": "hellblau färv",
  "item.minecraft.magenta_dye": "majenta färv",
  "item.minecraft.orange_dye": "orangsch färv",
  "item.minecraft.bone_meal": "knochemähl",
  "item.minecraft.blue_dye": "blaue färv",
  "item.minecraft.brown_dye": "brunge färv",
  "item.minecraft.black_dye": "schwatze färv",
  "item.minecraft.white_dye": "wieße färv",
  "item.minecraft.bone": "knoche",
  "item.minecraft.sugar": "zucker",
  "block.minecraft.cake": "koche",
  "block.minecraft.white_bed": "wieß bett",
  "block.minecraft.orange_bed": "orangsch bett",
  "block.minecraft.magenta_bed": "majenta bett",
  "block.minecraft.light_blue_bed": "hellblau bett",
  "block.minecraft.yellow_bed": "jäl bett",
  "block.minecraft.lime_bed": "helljrön bett",
  "block.minecraft.pink_bed": "rusa bett",
  "block.minecraft.gray_bed": "jrau bett",
  "block.minecraft.light_gray_bed": "helljrau bett",
  "block.minecraft.cyan_bed": "blaujrön bett",
  "block.minecraft.purple_bed": "vijelett bett",
  "block.minecraft.blue_bed": "blau bett",
  "block.minecraft.brown_bed": "brung bett",
  "block.minecraft.green_bed": "jrön bett",
  "block.minecraft.red_bed": "rut bett",
  "block.minecraft.black_bed": "schwatz bett",
  "item.minecraft.cookie": "plätzje",
  "item.minecraft.filled_map": "kaat□#0",
  "item.minecraft.shears": "schier",
  "item.minecraft.melon_slice": "meloneschiev",
  "item.minecraft.dried_kelp": "drüjje sietang",
  "item.minecraft.pumpkin_seeds": "kürbiskäne",
  "item.minecraft.melon_seeds": "melonekäne",
  "item.minecraft.beef": "rüh rindfleisch",
  "item.minecraft.cooked_beef": "böfstöck",
  "item.minecraft.chicken": "rüh hoon",
  "item.minecraft.cooked_chicken": "jebrode hoon",
  "item.minecraft.rotten_flesh": "ömjejange fleisch",
  "item.minecraft.ender_pearl": "enderpäl",
  "item.minecraft.blaze_rod": "förstang",
  "item.minecraft.ghast_tear": "jhast-tron",
  "item.minecraft.gold_nugget": "joldklumpe",
  "item.minecraft.nether_wart": "netherwaaz",
  "item.minecraft.potion": "nit braubare drank□kei wirkung",
  "item.minecraft.glass_bottle": "jlasfläsch",
  "item.minecraft.spider_eye": "spenneauch",
  "item.minecraft.fermented_spider_eye": "jejorre spenneauch",
  "item.minecraft.blaze_powder": "förstangstöbb",
  "item.minecraft.magma_cream": "machmakräm",
  "block.minecraft.brewing_stand": "braues",
  "block.minecraft.cauldron": "bütt",
  "item.minecraft.ender_eye": "enderauch",
  "item.minecraft.glistering_melon_slice": "jlitzernde meloneschiev",
  "item.minecraft.bat_spawn_egg": "fleddermuus-spawn-ei",
  "item.minecraft.bee_spawn_egg": "beie-spawn-ei",
  "item.minecraft.blaze_spawn_egg": "förmann-spawn-ei",
  "item.minecraft.cat_spawn_egg": "katze-spawn-ei",
  "item.minecraft.cave_spider_spawn_egg": "höhlespenne-spawn-ei",
  "item.minecraft.chicken_spawn_egg": "höhner-spawn-ei",
  "item.minecraft.cod_spawn_egg": "kabbeljau-spawn-ei",
  "item.minecraft.cow_spawn_egg": "koh-spawn-ei",
  "item.minecraft.creeper_spawn_egg": "kreeper-spawn-ei",
  "item.minecraft.dolphin_spawn_egg": "delfin-spawn-ei",
  "item.minecraft.donkey_spawn_egg": "äsel-spawn-ei",
  "item.minecraft.drowned_spawn_egg": "versoffener-spawn-ei",
  "item.minecraft.elder_guardian_spawn_egg": "jroße-waach-spawn-ei",
  "item.minecraft.enderman_spawn_egg": "enderman-spawn-ei",
  "item.minecraft.endermite_spawn_egg": "endermite-spawn-ei",
  "item.minecraft.evoker_spawn_egg": "majier-spawn-ei",
  "item.minecraft.fox_spawn_egg": "fuss-spawn-ei",
  "item.minecraft.ghast_spawn_egg": "jhast-spawn-ei",
  "item.minecraft.guardian_spawn_egg": "waach-spawn-ei",
  "item.minecraft.hoglin_spawn_egg": "hogling-spawn-ei",
  "item.minecraft.horse_spawn_egg": "päd-spawn-ei",
  "item.minecraft.husk_spawn_egg": "wöstezombi-spawn-ei",
  "item.minecraft.llama_spawn_egg": "lama-spawn-ei",
  "item.minecraft.magma_cube_spawn_egg": "machmaklötsch-spawn-ei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-spawn-ei",
  "item.minecraft.mule_spawn_egg": "muuläsel-spawn-ei",
  "item.minecraft.ocelot_spawn_egg": "jeflekte-katz-spawn-ei",
  "item.minecraft.panda_spawn_egg": "panda-spawn-ei",
  "item.minecraft.parrot_spawn_egg": "papejeie-spawn-ei",
  "item.minecraft.phantom_spawn_egg": "fantom-spawn-ei",
  "item.minecraft.pig_spawn_egg": "sau-spawn-ei",
  "item.minecraft.piglin_spawn_egg": "pigling-spawn-ei",
  "item.minecraft.pillager_spawn_egg": "plüngere-spawn-ei",
  "item.minecraft.polar_bear_spawn_egg": "iesbär-spawn-ei",
  "item.minecraft.pufferfish_spawn_egg": "kujelfesch-spawn-ei",
  "item.minecraft.rabbit_spawn_egg": "kning-spawn-ei",
  "item.minecraft.ravager_spawn_egg": "wöderich-spawn-ei",
  "item.minecraft.salmon_spawn_egg": "lachs-spawn-ei",
  "item.minecraft.sheep_spawn_egg": "schof-spawn-ei",
  "item.minecraft.shulker_spawn_egg": "shulker-spawn-ei",
  "item.minecraft.silverfish_spawn_egg": "selverfeschje-spawn-ei",
  "item.minecraft.skeleton_spawn_egg": "jereppe-spawn-ei",
  "item.minecraft.skeleton_horse_spawn_egg": "pädsjereppe-spawn-ei",
  "item.minecraft.slime_spawn_egg": "schliem-spawn-ei",
  "item.minecraft.spider_spawn_egg": "spenne-spawn-ei",
  "item.minecraft.squid_spawn_egg": "inkfesch-spawn-ei",
  "item.minecraft.stray_spawn_egg": "vajabund-spawn-ei",
  "item.minecraft.strider_spawn_egg": "schreiter-spawn-ei",
  "item.minecraft.trader_llama_spawn_egg": "kriemerlama-spawn-ei",
  "item.minecraft.tropical_fish_spawn_egg": "tropefesch-spawn-ei",
  "item.minecraft.turtle_spawn_egg": "scheldkraate-spawn-ei",
  "item.minecraft.vex_spawn_egg": "vexeerer-spawn-ei",
  "item.minecraft.villager_spawn_egg": "enwonner-spawn-ei",
  "item.minecraft.vindicator_spawn_egg": "deener-spawn-ei",
  "item.minecraft.wandering_trader_spawn_egg": "kriemer-spawn-ei",
  "item.minecraft.witch_spawn_egg": "hexe-spawn-ei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherjerepp-spawn-ei",
  "item.minecraft.wolf_spawn_egg": "wolf-spawn-ei",
  "item.minecraft.zoglin_spawn_egg": "zogling-spawn-ei",
  "item.minecraft.zombie_spawn_egg": "zombi-spawn-ei",
  "item.minecraft.zombie_horse_spawn_egg": "zombipäd-spawn-ei",
  "item.minecraft.zombie_villager_spawn_egg": "zombi-enwonner-spawn-ei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifizeete-pigling-spawn-ei",
  "item.minecraft.experience_bottle": "erfahrongsfläsch",
  "item.minecraft.fire_charge": "förkuchel",
  "item.minecraft.writable_book": "boch un fädder",
  "item.minecraft.written_book": "jeschrivve boch",
  "item.minecraft.emerald": "smarak",
  "item.minecraft.item_frame": "rohme",
  "block.minecraft.flower_pot": "blomepot",
  "item.minecraft.carrot": "mohr",
  "item.minecraft.potato": "ädappel",
  "item.minecraft.baked_potato": "quallmann",
  "item.minecraft.poisonous_potato": "jefftije ädappel",
  "item.minecraft.map": "leddisch kaat",
  "item.minecraft.golden_carrot": "jolden mohr",
  "block.minecraft.skeleton_skull": "dudekopp",
  "block.minecraft.wither_skeleton_skull": "witherjereppdudekopp",
  "block.minecraft.player_head": "spillerkopp",
  "block.minecraft.zombie_head": "zombikopp",
  "block.minecraft.creeper_head": "kreeperkopp",
  "block.minecraft.dragon_head": "drachekopp",
  "item.minecraft.carrot_on_a_stick": "mohr am stock",
  "item.minecraft.warped_fungus_on_a_stick": "jeckepelz am stock",
  "item.minecraft.nether_star": "netherstän",
  "item.minecraft.pumpkin_pie": "kürbiskooche",
  "item.minecraft.firework_rocket": "förwerksraket",
  "item.minecraft.firework_star": "förwerksstän",
  "item.minecraft.enchanted_book": "verzaubert boch",
  "item.minecraft.nether_brick": "netherziejel",
  "item.minecraft.quartz": "netherkwarz",
  "item.minecraft.tnt_minecart": "sprengkar",
  "item.minecraft.hopper_minecart": "treechtekar",
  "item.minecraft.prismarine_shard": "prismarinscherv",
  "item.minecraft.prismarine_crystals": "prismarinkrestall",
  "item.minecraft.rabbit": "rüh kning",
  "item.minecraft.cooked_rabbit": "jebrode kning",
  "item.minecraft.rabbit_stew": "kningszupp",
  "item.minecraft.rabbit_foot": "kningsklau",
  "item.minecraft.rabbit_hide": "kningspelz",
  "item.minecraft.armor_stand": "röstungsständer",
  "item.minecraft.iron_horse_armor": "ieser pädsharnisch",
  "item.minecraft.golden_horse_armor": "joldene pädsharnisch",
  "item.minecraft.diamond_horse_armor": "dijamantene pädsharnisch",
  "item.minecraft.leather_horse_armor": "ledderne pädsharnisch",
  "item.minecraft.lead": "ling",
  "item.minecraft.name_tag": "namescheld",
  "item.minecraft.command_block_minecart": "befellsblockkar",
  "item.minecraft.mutton": "rüh schofsfleisch",
  "item.minecraft.cooked_mutton": "jebrode schofsfleisch",
  "block.minecraft.white_banner": "wieße fahn",
  "block.minecraft.orange_banner": "orangsch fahn",
  "block.minecraft.magenta_banner": "majenta fahn",
  "block.minecraft.light_blue_banner": "hellblau fahn",
  "block.minecraft.yellow_banner": "jäl fahn",
  "block.minecraft.lime_banner": "helljrön fahn",
  "block.minecraft.pink_banner": "rusa fahn",
  "block.minecraft.gray_banner": "jrau fahn",
  "block.minecraft.light_gray_banner": "helljrau fahn",
  "block.minecraft.cyan_banner": "blaujrön fahn",
  "block.minecraft.purple_banner": "vijelett fahn",
  "block.minecraft.blue_banner": "blau fahn",
  "block.minecraft.brown_banner": "brung fahn",
  "block.minecraft.green_banner": "jrön fahn",
  "block.minecraft.red_banner": "rut fahn",
  "block.minecraft.black_banner": "schwatze fahn",
  "item.minecraft.end_crystal": "endkrestall",
  "item.minecraft.chorus_fruit": "chorusfruch",
  "item.minecraft.popped_chorus_fruit": "jeplatzte chorusfruch",
  "item.minecraft.beetroot": "rude bete",
  "item.minecraft.beetroot_seeds": "rude-bete-some",
  "item.minecraft.beetroot_soup": "rude-bete-zupp",
  "item.minecraft.dragon_breath": "dracheodem",
  "item.minecraft.splash_potion": "nit braubare werpdrank□kei wirkung",
  "item.minecraft.spectral_arrow": "spektralpiel",
  "item.minecraft.tipped_arrow": "nit herstellbare jedränkte piel□kei wirkung",
  "item.minecraft.lingering_potion": "blievende nit braubare drank□kei wirkung",
  "item.minecraft.shield": "scheld",
  "item.minecraft.elytra": "flöjel",
  "item.minecraft.spruce_boat": "danneholzböötche",
  "item.minecraft.birch_boat": "birkeholzböötche",
  "item.minecraft.jungle_boat": "tropeholzböötche",
  "item.minecraft.acacia_boat": "akazijeholzböötche",
  "item.minecraft.dark_oak_boat": "schwatzeescheholzböötche",
  "item.minecraft.totem_of_undying": "totem vun dä onstervlichkeit",
  "item.minecraft.shulker_shell": "shulkerschal",
  "item.minecraft.iron_nugget": "ieseklumpe",
  "item.minecraft.knowledge_book": "boch vum wesse",
  "item.minecraft.debug_stick": "debug-stock",
  "item.minecraft.music_disc_13": "musikplaat□c418 - 13",
  "item.minecraft.music_disc_cat": "musikplaat□c418 - katz",
  "item.minecraft.music_disc_blocks": "musikplaat□c418 - blöck",
  "item.minecraft.music_disc_chirp": "musikplaat□c418 - schirp",
  "item.minecraft.music_disc_far": "musikplaat□c418 - far",
  "item.minecraft.music_disc_mall": "musikplaat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musikplaat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musikplaat□c418 - stal",
  "item.minecraft.music_disc_strad": "musikplaat□c418 - strad",
  "item.minecraft.music_disc_ward": "musikplaat□c418 - ward",
  "item.minecraft.music_disc_11": "musikplaat□c418 - 11",
  "item.minecraft.music_disc_wait": "musikplaat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musikplaat□lena raine ‐ pigstep",
  "item.minecraft.trident": "dreizack□□en dä hauphand:□+8 anjreffsschade□-2.9 anjreffsjeschwindechkeet",
  "item.minecraft.phantom_membrane": "fantomhuck",
  "item.minecraft.nautilus_shell": "nautiluschal",
  "item.minecraft.heart_of_the_sea": "meerhätz",
  "item.minecraft.crossbow": "ärmbruß",
  "item.minecraft.suspicious_stew": "zuspekte zupp",
  "block.minecraft.loom": "wevstohl",
  "item.minecraft.flower_banner_pattern": "fahnevörlach□blom",
  "item.minecraft.creeper_banner_pattern": "fahnevörlach□kreeper",
  "item.minecraft.skull_banner_pattern": "fahnevörlach□dudekopp",
  "item.minecraft.mojang_banner_pattern": "fahnevörlach□mojang-wappe",
  "item.minecraft.globe_banner_pattern": "fahnevörlach□jlobus",
  "item.minecraft.piglin_banner_pattern": "fahnevörlach□schnüß",
  "block.minecraft.composter": "kompoß",
  "block.minecraft.barrel": "faaß",
  "block.minecraft.smoker": "räucherovve",
  "block.minecraft.blast_furnace": "schmelzovve",
  "block.minecraft.cartography_table": "kaatedesch",
  "block.minecraft.fletching_table": "pielmächerdesch",
  "block.minecraft.grindstone": "schliefstein",
  "block.minecraft.lectern": "lesepult",
  "block.minecraft.smithing_table": "schmiddedesch",
  "block.minecraft.stonecutter": "steinsäch",
  "block.minecraft.bell": "klock",
  "block.minecraft.lantern": "latän",
  "block.minecraft.soul_lantern": "sielelatän",
  "item.minecraft.sweet_berries": "sößbere",
  "block.minecraft.campfire": "förstell",
  "block.minecraft.soul_campfire": "sieleförstell",
  "block.minecraft.shroomlight": "pelzleech",
  "item.minecraft.honeycomb": "honnichwov",
  "block.minecraft.bee_nest": "beieneß",
  "block.minecraft.beehive": "beiestock",
  "item.minecraft.honey_bottle": "honnichfläsch",
  "block.minecraft.honey_block": "honnichblock",
  "block.minecraft.honeycomb_block": "honnichwoveblock",
  "block.minecraft.lodestone": "leitstein",
  "block.minecraft.netherite_block": "netheritblock",
  "block.minecraft.ancient_debris": "ahle schrott",
  "block.minecraft.target": "zillblock",
  "block.minecraft.crying_obsidian": "krieschende obssidijan",
  "block.minecraft.blackstone": "schwatzstein",
  "block.minecraft.blackstone_slab": "schwatzsteinstof",
  "block.minecraft.blackstone_stairs": "schwatzsteintrapp",
  "block.minecraft.gilded_blackstone": "verjoldete schwatzstein",
  "block.minecraft.polished_blackstone": "poleete schwatzstein",
  "block.minecraft.polished_blackstone_slab": "poleete schwatzsteinstof",
  "block.minecraft.polished_blackstone_stairs": "poleete schwatzsteintrapp",
  "block.minecraft.chiseled_polished_blackstone": "ziseleete poleete schwatzstein",
  "block.minecraft.polished_blackstone_bricks": "poleete schwatzsteinziejel",
  "block.minecraft.polished_blackstone_brick_slab": "poleete schwatzsteinziejelstof",
  "block.minecraft.polished_blackstone_brick_stairs": "poleete schwatzsteinziejeltrapp",
  "block.minecraft.cracked_polished_blackstone_bricks": "jeresse poleete schwatzsteinziejel",
  "block.minecraft.respawn_anchor": "sieleanker",
}
export const ksh = items; 
